import React from 'react'
import PropTypes from 'prop-types'
import { AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTES, TONE } from '../../data/constants'
import styles from './StatGroup.module.scss'

export default function StatGroup({ items = [] }) {
  if (items.length === 0) return null

  return (
    <div className={`${styles.grid} d-grid gap-2`} {...AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTES}>
      {items.map((item) => (
        <div key={item.key} className={styles.stat}>
          <div
            className={[styles.value, item.tone ? styles[item.tone] : '', item.truncateValue ? 'text-truncate' : '']
              .filter(Boolean)
              .join(' ')}
          >
            {item.value}
            {item.denom !== undefined && <small> / {item.denom}</small>}
          </div>
          <div className={styles.label}>{item.label}</div>
        </div>
      ))}
    </div>
  )
}

StatGroup.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.node.isRequired,
      denom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      tone: PropTypes.oneOf(Object.values(TONE)),
      truncateValue: PropTypes.bool,
      label: PropTypes.node.isRequired,
    }),
  ),
}
